class ProdEnvironment {
    signupDirect = 'https://gateway.prod.bill.com/signupservice/v1/signup/marketing';
    signupConsole = 'https://app-signup.us.bill.com/ConsoleSignup1';
    brInviteUrl = 'https://api.bill.com/api/v2/GetVendorInvitesExternal';
    brSignupPageUrl = 'https://app-signup.us.bill.com/onboarding/flow/signup';
    ffaas= 'https://app01.us.bill.com/neo3/ffaaslink/graphql';
    munchkinId = '258-FEM-750';
    segmentKey = 'b7SQxIgzchmkwydmWraoO2NRdwi0dRyq';
    directPricePlan = 'ppl01YLEUOPIFHFH2gb4';
    consolePricePlan = 'ppl01PERIFSIJAID2gb8';
    leanDataBookitOrgId = '00D4x0000017X4DEAU';
}

class DevEnvironment extends ProdEnvironment {
    signupDirect = 'https://gateway-test.us.cashview.com/signupservice/v1/signup/marketing';
    signupConsole = 'https://app-signup-test.qa.cashview.com/ConsoleSignup1';
    brInviteUrl = 'https://app-test.cashview.com/api/v2/GetVendorInvitesExternal';
    brSignupPageUrl = 'https://app-signup-test.qa.cashview.com/onboarding/flow/signup';
    ffaas= 'https://app-test01.qa.cashview.com/neo3/ffaaslink/graphql';
    munchkinId = '117-IJE-550';
    segmentKey = 's5AojTRfV9Kts1U5SOpTrIgnOjFucioX';
    directPricePlan = 'ppl01FZCVEEKYLSONmgs';
    consolePricePlan = 'ppl01YMKIKFUEQHBLmgq';
    leanDataBookitOrgId = '00DWB0000042tbV2AQ';
}

class StageEnvironment extends ProdEnvironment {
    signupDirect = 'https://gateway.stage.bill.com/signupservice/v1/signup/marketing';
    signupConsole = 'https://app-signup-stage.us.bill.com/ConsoleSignup1';
    brInviteUrl = 'https://app-stage.cashview.com/api/v2/GetVendorInvitesExternal';
    brSignupPageUrl = 'https://app-signup-stage.us.bill.com/onboarding/flow/signup';
    ffaas= 'https://app-stage01.us.bill.com/neo3/ffaaslink/graphql';
    munchkinId = '117-IJE-550';
    segmentKey = 's5AojTRfV9Kts1U5SOpTrIgnOjFucioX';
    directPricePlan = 'ppl01FHHBMCLTUKVG76o';
    consolePricePlan = 'ppl01SRIFYOKPCHNJ714';
    leanDataBookitOrgId = '00DWB0000042tbV2AQ';
}

const isDev = window.location.host.includes('dev') || window.location.host.includes('test');
const isStg = isDev && window.location.href.includes('env=stage');
export const environment =  isStg ? new StageEnvironment() :
                            isDev ? new DevEnvironment() :
                                    new ProdEnvironment();